// Where the candidate's login is kept in the browser.
//
// sessionStorage, not localStorage: the browser deletes it when the window is closed, so closing the exam
// and opening a page's URL again finds no login and goes to the login page instead of resuming. A reload
// of the same window keeps it. The server still decides whether a login is valid; this only stops a
// closed browser from carrying one.

const AUTH = "EXAMINATION_SOFTWARE_AUTH";
const SUBJECT = "EXAMINATION_SOFTWARE_SUBJECT";

// Logins saved by earlier versions in localStorage would otherwise survive forever
localStorage.removeItem(AUTH);
localStorage.removeItem(SUBJECT);

const read = (key) => {
    try {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch (e) {
        return null;
    }
};

export const getStoredAuth = () => read(AUTH);
export const getStoredSubject = () => read(SUBJECT);
export const storeAuth = (data) => sessionStorage.setItem(AUTH, JSON.stringify(data));
export const storeSubject = (data) => sessionStorage.setItem(SUBJECT, JSON.stringify(data));

// The exams fetched at the Aadhaar step only
export const clearStoredSubject = () => sessionStorage.removeItem(SUBJECT);

export const clearStoredAuth = () => {
    sessionStorage.removeItem(AUTH);
    sessionStorage.removeItem(SUBJECT);
};
